<template>
  <svg width="18" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.833 1.667h12c.825 0 1.5.675 1.5 1.5v9c0 .825-.674 1.5-1.5 1.5h-12c-.825 0-1.5-.675-1.5-1.5v-9c0-.825.676-1.5 1.5-1.5z" stroke="#ADADAD" stroke-width="2"/>
    <path d="M16.334 3.167l-7.5 5.25-7.5-5.25" stroke="#ADADAD" stroke-width="2"/>
  </svg>
</template>
